import React from "react";

export const LoadingMessage = () => {
  // !! KEEP THIS IN SYNC WITH index.html !!
  return (
    <div className="LoadingMessage">
      <span>{"Loading scene..."}</span>
    </div>
  );
};
